import { PrimitiveValueObject } from '@/domain/primitiveValueObject';

export class NurseryId extends PrimitiveValueObject<string> {
  /**
   * 生成
   * @param value 値
   * @returns 値
   */
  static create(value: string): NurseryId {
    return new NurseryId(value);
  }
}
